import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=ed663394&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed663394')) {
      api.createRecord('ed663394', component.options)
    } else {
      api.reload('ed663394', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=ed663394&", function () {
      api.rerender('ed663394', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/auth/ResetPassword.vue"
export default component.exports